import {defineStore} from "pinia";
import DivisionAPI from "@/api/DivisionAPI";
import {
  utcToLocal,
} from "@/internal";

export const useDivisionStore = defineStore('division', {
  state: () => ({
    data: [],
  }),
  actions: {
    clear() {
      this.data = [];
    },
    find(id) {
      return this.data.find(data => parseInt(data.id) === parseInt(id)) || null;
    },
    index(payload) {
      const { params } = payload;

      return new DivisionAPI().index(params)
      .then((response) => {
        this.data = response.data;
        return response;
      });
    },
  },
  persist: true,
});
